import { SSO_PROVIDER } from 'src/constants/authorization';

export default () => {
  return {
    userDetails: { },

    emailVerified: null,

    newUserInfo: null,

    /** Bind clients that are associated to current user */
    associatedClients: [],
    /**
     * Details about the clinic that's associated with the user's account
     */
    connectedClinic: { },
    /**
     * Info about the currently selected client.
     */
    currentClient: { },

    /**
     * Client's id that is allowed to be set as current client without being auto-unselected
     */
    deactivatedClientAllowedToView: null,

    /**
     * Hold timestamps for certain recent updates to clinic settings to make it
     * easier to determine when settings need to be refreshed
     */
    clinicSettingsUpdates: { },

    /**
     * Info about scheduled appointments
     */
    clientAppointmentsInProgress: null,
    clientAppointmentsUpcoming: null,
    clientAppointmentsRecurring: null,

    userAppointments: null,
    loadPastUserAppointments: false,
    userAppointmentsLimit: 10,

    userAppointmentsInProgress: null,
    showDefaultTreatmentAreas: false,
    showDefaultProgramDataFields: false,

    /**
     * Billing object (only applicable if user is a clinic)
     */
    billing: { },

    /**
     * Auth claims belonging to current user
     */
    claims: {},

    /**
     * Remember user session
     */
    rememberMe: '',

    /*
    * Provider used to sign in
    * */
    provider: 'password',

    /**
     * All providers linked with user
     */
    allUserProviders: [],

    /*
    * Pending oAuth credential when user wants to sign in with new provider
    * */
    pendingCredential: null,

    /*
    * List of possible sso providers
    * */
    ssoProviders: [SSO_PROVIDER.MICROSOFT, SSO_PROVIDER.GOOGLE, SSO_PROVIDER.APPLE],

    showLoader: false,

    userPrivilegeLabels: {},

    userPrivileges: {},

    userSettings: {},

    allowImmediateSync: false,

    appointmentThreshold: 8 * 60 * 60, // Default threshold for starting appointments is 8 hours

    careModelCohorts: [],

    treatmentServices: [],
    isLoadingTreatmentServices: false,

    placesOfService: [],
    isLoadingPlacesOfService: false,

    cancellationReasons: [],

    useSessionPrototypes: false,
    strictSessionNaming: false,
    evvRequired: false,
    useLegalNameInSignature: false,
    useBetaProgramImport: false,
    autoImportClients: false,

    clinicNotificationSettings: {},

    activityTypesSettings: {},

    businessHoursSlots: [],

    /** @type {{
     * pageHeaderContent: string,
     * pageFooterContent: string,
     * showPageFooter: boolean,
     * showPageHeader: boolean
     * }}
     */
    sessionNotesLayoutSettings: {},

    integrationSettings: {},

    /** @type {'active' | 'expiring' | 'expired' | null} */
    authSessionStatus: null,

    /** @type {number | null} Auto logout session duration in milliseconds. */
    authSessionsDuration: null,

    loginAt: null,

    /** @type {Worker | null} */
    authSessionWorker: null,

    /**
     * Treatment trajectory settings (thresholds, custom labels, colors, and enabled status)
     * @type {{ isEnabled?: boolean, statuses?: Record<string, Object> }}
     */
    trajectorySettings: {},
  };
};
